
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Ban } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // Check if this might be a direct lead link
    const pathParts = location.pathname.split('/');
    if (pathParts.length === 3 && pathParts[1] === 'lead') {
      console.warn("This appears to be a lead link. Checking if it's a server routing issue.");
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <Card className="max-w-md w-full shadow-lg border-slate-200 animate-slide-in-bottom">
        <CardContent className="p-8 text-center flex flex-col items-center">
          <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mb-6">
            <Ban className="h-10 w-10 text-slate-400" />
          </div>

          <h1 className="text-4xl font-bold text-slate-900 mb-2">404</h1>
          <h2 className="text-xl font-semibold text-slate-700 mb-4">Η σελίδα δεν βρέθηκε</h2>

          <p className="text-slate-500 mb-6 leading-relaxed">
            Η σελίδα που προσπαθείτε να επισκεφθείτε δεν υπάρχει ή έχει μετακινηθεί.
          </p>

          <Link to="/" className="w-full">
            <Button className="w-full btn-gradient">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Επιστροφή στην αρχική
            </Button>
          </Link>

          <div className="mt-8 pt-6 border-t border-slate-100 w-full">
            <p className="text-xs text-slate-400">
              Αν πιστεύετε ότι πρόκειται για λάθος του συστήματος, παρακαλώ επικοινωνήστε με τον διαχειριστή.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
